module.exports = __webpack_public_path__ + "static/media/verification_code_web.c889efb1.webp";